
const ms171 = {
  label: "NPA Master",
  pageLabel: "NPA master",
  starting: true,
  url: "ms171",
  pageType: "history",
  formTabs: {
    allTabs: [
      {
        label: "Filter Option",
        uid: "filteroption",
        style: { fontFamily: "verdana" }
      },
      {
        label: "NPA Master",
        uid: "npamaster",
        style: { fontFamily: "verdana" }
      }
    ]
  },
  form: [
    {
      inputType: "displaytext",
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "From Date",
      name: "",
      description: "Enter From Date"
    },
    {
      inputType: "date",
      dateType: "ontype",
      isRequired: true,
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "As on Date",
      displayFormat: "DD/MM/YYYY",
      outputFormat: "YYYYMMDD",
      name: "From_Date",
      description: "Enter From Date"
    },
    {
      inputType: "displaytext",
      tab: "filteroption",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: "Enter Search"
    },

    {
      inputType: "displaytext",
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Search",
      name: "",
      description: "Enter Search"
    },
    {
      inputType: "text",
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "Search",
      name: "Search",
      description: "Enter Search"
    },
    {
      inputType: "displaytext",
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Name",
      name: "",
      description: "Enter Name"
    },
    {
      inputType: "text",
      tab: "filteroption",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "Name",
      name: "Name",
      description: "Enter Name"
    },
    {
      inputType: "displaytext",
      tab: "filteroption",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: ""
    },
    {
      inputType: "displaytext",
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "No of Records",
      name: "",
      description: "Enter No of Records"
    },
    {
      inputType: "text",
      tab: "filteroption",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "No of Records",
      name: "Norecords",
      description: "Enter No of Records"
    },
    {
      inputType: "checkbox",
      tab: "filteroption",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "Active",
      description: "Active"
    },
    {
      inputType: "displaytext",
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "As on Date",
      name: "",
      description: "Enter From Date"
    },
    {
      inputType: "date",
      dateType: "ontype",
      isRequired: true,
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "As on Date",
      displayFormat: "DD/MM/YYYY",
      outputFormat: "YYYYMMDD",
      name: "asondate",
      description: "Enter As on Date"
    },
    {
      inputType: "checkbox",
      tab: "npamaster",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "Active",
      label: "Active",
      name: "Active",
      description: "Active"
    },
    {
      inputType: "displaytext",
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Code",
      name: "",
      description: "Enter Code"
    },
    {
      inputType: "text",
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "code",
      description: "Enter Code"
    },
    {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-8",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "",
        description: "Enter Code"
      },
    {
      inputType: "displaytext",
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Name",
      name: "",
      description: "Enter Name"
    },
    {
      inputType: "text",
      tab: "npamaster",
      widths: {
        parent: "col-sm-4",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "Name",
      description: "Enter Name"
    },
    {
      inputType: "displaytext",
      tab: "npamaster",
      widths: {
        parent: "col-sm-6",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "",
      description: "Enter Name"
    },
    {
      inputType: "displaytext",
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "Period",
      name: "",
      description: "Enter Period"
    },
    {
      inputType: "text",
      tab: "npamaster",
      widths: {
        parent: "col-sm-2",
        children: "col-sm-12"
      },
      placeHolder: "",
      label: "",
      name: "Period",
      description: "Enter Period"
    },
    {
      inputType: "checkbox",
      tab: "npamaster",
      isRequired: true,
      default: "false",
      widths: {
        parent: "col-sm-8",
        children: "col-sm-12"
      },
      placeHolder: "Days",
      label: "Days",
      name: "Days",
      description: "Days"
    },
    {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Agriculture Loan Period",
        name: "",
        description: "Enter Agriculture Loan Period"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-2",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "Loan_Period",
        description: "Enter Agriculture Loan Period"
      },
      {
        inputType: "checkbox",
        tab: "npamaster",
        isRequired: true,
        default: "false",
        widths: {
          parent: "col-sm-8",
          children: "col-sm-12"
        },
        placeHolder: "Days",
        label: "Days",
        name: "days",
        description: "Days"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Balance Percent(Secured)",
        name: "",
        description: "Enter Balance Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "Balance_Percent",
        description: "Enter Balance Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Interest Percent(Secured)",
        name: "",
        description: "Enter Interest Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "Interest_Percent",
        description: "Enter Interest Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Balance Percent(UnSecured)",
        name: "",
        description: "Enter Balance Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "balanceunsecure",
        description: "Enter Balance Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Interest Percent(UnSecured)",
        name: "",
        description: "Enter Interest Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "interestunsecure",
        description: "Enter Interest Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-12",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "For Builders",
        name: "",
        description: ""
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Balance Percent(Secured)",
        name: "",
        description: "Enter Balance Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "Balance_Percent1",
        description: "Enter Balance Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Interest Percent(Secured)",
        name: "",
        description: "Enter Interest Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "Interest_Percent1",
        description: "Enter Interest Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Balance Percent(UnSecured)",
        name: "",
        description: "Enter Balance Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "balanceunsecure1",
        description: "Enter Balance Percent"
      },
      {
        inputType: "displaytext",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "Interest Percent(UnSecured)",
        name: "",
        description: "Enter Interest Percent"
      },
      {
        inputType: "text",
        tab: "npamaster",
        widths: {
          parent: "col-sm-3",
          children: "col-sm-12"
        },
        placeHolder: "",
        label: "",
        name: "interestunsecure1",
        description: "Enter Interest Percent"
      },
  ]
};
export default ms171;
